<template>
  <div class="banner">
    <el-carousel height="300px">
      <el-carousel-item v-for="(item,key) in bannerlist" :key="key" @click="bannertz(item.turl)">
        <div class="banner-item">
          <el-image :src="`${proxy.$imgurl}${item.bfm}`"></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { reactive, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();
let bannerlist=reactive([])
const getbanner = () => {
  get("/api/NewsPaper/GetBannalList").then((res) => {
    // console.log(res)
    bannerlist.push(...res.Data)
  });
};
getbanner();
// 点击跳转
const bannertz=val=>{
  if(val=="" || val==null){
    return false
  }
  window.open(val)
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 300px;
}
.banner-item {
  width: 100%;
  height: 300px;
  cursor: pointer;
  background: #12507b;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
</style>
